<vectronic-card [title]="confirmTitle" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body>
    <div class="card-body">
      <div md-dialog-content class="content" [class.monospace]="data?.useMonospaceFont">
        {{ confirmMessage }}
      </div>
      @if (data?.toggleText) {
        <mat-checkbox [checked]="toggle" (change)="toggle = !toggle" color="accent">
          {{ data.toggleText }}
        </mat-checkbox>
      }
      <div md-dialog-actions class="actions-button">
        @if (!data?.hideCancel) {
          <button
            mat-button
            class="close-button"
            [mat-dialog-close]="true"
            (click)="dialogRef.close(false)"
          >
            <mat-icon color="warn">cancel</mat-icon>
            {{ cancelText }}
          </button>
        }
        <button mat-button (click)="dialogRef.close({ toggle })" cdkFocusInitial>
          <mat-icon color="accent">check_circle</mat-icon>
          {{ confirmText }}
        </button>
      </div>
    </div>
  </ng-container>
</vectronic-card>
